var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 44,
    viewBox: "0 0 33 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(0.426 0.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M24.362,12.822a3.851,3.851,0,0,1-3.847-3.847V0H3.847A3.851,3.851,0,0,0,0,3.847V39.919a3.851,3.851,0,0,0,3.847,3.847H29.49a3.851,3.851,0,0,0,3.847-3.847v-27.1Z",
    transform: "translate(-0.223 -0.345)",
    fill: "#2b3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M203.782,16.1h8.224L202.5,6.59v8.224a1.283,1.283,0,0,0,1.282,1.282",
    transform: "translate(-179.644 -6.184)",
    fill: "#2b3385"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon_document.352880b2a9694a2061952ffa690c0d3c.svg";
export { ForwardRef as ReactComponent };